export{u as useTheme,z as zipThemes}from"./useTheme-e8aabdea.js";
//# sourceMappingURL=theme.js.map
